"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4312],{

/***/ 64312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ foodProgram_Advantages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 1 modules
var Trans = __webpack_require__(59251);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/advantages/affordable.png
/* harmony default export */ var affordable = ({"src":"/_next/static/media/affordable.f5be4872.png","height":550,"width":562,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAflBMVEWVlYKoqnqsyI6HgnfLysGji0e74ZS9hkHGw2vAgVpPVVW1vYPI4+3Z9caMez2VYC+hokbK3aLh7L7D7ZDc5Kq/44zE24/D3pzHyE2goaD///+AgIJrYmeCiF2ZcDu1cEOkgTnS0K9yYSi2topwjDe+2YTX+Km5yIZxcmqdpXqT9Z5rAAAAHnRSTlMBikpw9P5v/v39kZVnG/r9+/t675nC3ar64Ar2x/zeC7EUAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAR0lEQVR4nBXLRRaAIABAwa+AYHd36/0v6HP2A05dZCFAeaWrDMCujsh1pSA/1TTHe4tjtN7U3YO/6KR5B8AyZnzE/2zPs7oPhmoDpPaCNCEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/advantages/highQuality.png
/* harmony default export */ var highQuality = ({"src":"/_next/static/media/highQuality.7927b451.png","height":550,"width":536,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAh1BMVEVMaXGhnY37/vSqqafN3KGdbDV9fGjs9LWVhGCNjmqGk2u1vZHe56/Dj212YkulhHGSXzuye0uPcDmMckdtTSDDlE57d2S9pHbr77KNhHFoXzvHyJ2VkVrHyqb////Ew8S3vbHKysk7ODuLeW5waFKYb0vV3qd8Zli6jm5QThCsgEeBbFDp498scf+eAAAAI3RSTlMA/v17I/3maf5qJpG3d/PK/M78gfn9/vvC/Tjn+8kN0dLfUdvT4GIAAAAJcEhZcwAAFiUAABYlAUlSJPAAAABGSURBVHicBcGFAYAwAMCwMmDD3d39//tIAOW5DoA6LCvwgWrNzGi3Gdq1uJMzhH6rn/yKWaSmmeWWon9CdK800OdxshuDH41bBFOmiEQAAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/advantages/personal.png
/* harmony default export */ var personal = ({"src":"/_next/static/media/personal.47be9f7d.png","height":550,"width":515,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAeFBMVEVMaXHQyr7C4pbK4pePdXSlrYV/hn1pW1paGiizlY5pbmGBeG98cmB2OEJLCxt1L0DU5qpRTEihgG59RkbFsK4mBhGvnJTk0c+em3S8vpvp6bGlz2zf6qn3/7iTk5SAWFegkYNDFBmvqZ2ZiIHFxs/S5bOrsJrk5rr8vEjiAAAAHnRSTlMA/en3/hTE/v3+XDne/erbKobMm/7N/vqv4SRVYkEKGAr1AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAQElEQVR4nAXBBQKAIAAAsaMU7G6x9f8/dINpWQFm9b1BDFIJf4UR8hGncwnj3el9Sxl834RHhgm8trYGU7Z5Vfxt4gN2+gPKBgAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/advantages/quick.png
/* harmony default export */ var quick = ({"src":"/_next/static/media/quick.73a6a83c.png","height":550,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAdVBMVEVVVVXLzqqel5czODyOa2csKjbm9bT//9V4hoG+uLO3ubmZmZFjSEdfcWyOlpxYSEuopJUWJjo6Q1N9fn6AfX2ytpni7LLE6pC42oqQl3uzxojl6LDq8LN2ZWg3SGFYaHaFjJBFR1avp6N7gHVVZ1C935LO5pyhvtjdAAAAHXRSTlMBnf78/v0ZBmX9gab97Ov9hfvarZ/ofN6D/elbo6XjNUQAAAAJcEhZcwAAFiUAABYlAUlSJPAAAABBSURBVHicBcEFAoAgAACxIwTsbsH2/090g3UbDDB98507y/gqXR4JyxPpzBf0p/I+7Ig4lnVosOklo70CXNcK8wN5NwOKuyktDAAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
// EXTERNAL MODULE: ./src/static_pages/foodProgram/Utils.tsx
var Utils = __webpack_require__(54397);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/static_pages/foodProgram/Advantages.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n\n  ",
        " {\n    gap: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  text-align: start;\n  gap: ",
        "px;\n\n  ",
        " {\n    gap: ",
        "px;\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var ADVANTAGES = [
    {
        titleKey: "advantages.personal.title",
        descriptionKey: "advantages.personal.description",
        image: personal
    },
    {
        titleKey: "advantages.quick.title",
        descriptionKey: "advantages.quick.description",
        image: quick
    },
    {
        titleKey: "advantages.highQuality.title",
        descriptionKey: "advantages.highQuality.description",
        image: highQuality
    },
    {
        titleKey: "advantages.affordable.title",
        descriptionKey: "advantages.affordable.description",
        image: affordable
    }, 
];
var Advantages = function(props) {
    var theme = (0,styled_components_browser_esm.useTheme)();
    var t = (0,useTranslation/* useTranslation */.$)("food_program").t;
    var isSm = (0,useBreakpoints/* useBreakpointDown */.a)("xs");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "section",
        textAlign: "center"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                size: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils/* FoodProgramH2 */.s, {
                    mb: 9,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                        t: t,
                        i18nKey: "advantages.title",
                        components: {
                            "1": /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "2": /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                as: "span",
                                color: theme.palette.secondary[400]
                            }, "1")
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                size: 960,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvantageList, {
                    children: ADVANTAGES.map(function(param, index) {
                        var titleKey = param.titleKey, descriptionKey = param.descriptionKey, image = param.image;
                        var imgOrder = 0;
                        if (!(index % 2 === 0)) {
                            imgOrder = 1;
                        }
                        if (isSm) {
                            imgOrder = 0;
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Advantage, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                    flexShrink: "0",
                                    order: imgOrder,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvantageImage, {
                                        src: image
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                    flexGrow: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                        flexDirection: "column",
                                        display: "flex",
                                        maxWidth: 650,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvantageTitle, {
                                                children: t(titleKey)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvantageDescription, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                                                    t: t,
                                                    i18nKey: descriptionKey,
                                                    components: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "1")
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, titleKey);
                    })
                })
            })
        ]
    }));
};
var AdvantageList = styled_components_browser_esm["default"].div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(4);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(5);
});
var AdvantageImage = function(props) {
    var isSm = (0,useBreakpoints/* useBreakpointDown */.a)("sm");
    var baseWidth = 257;
    var baseHeight = 275;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: props.src,
        width: isSm ? baseWidth * 0.8 : baseWidth,
        height: isSm ? baseHeight * 0.8 : baseHeight,
        objectFit: "contain",
        alt: ""
    });
};
var Advantage = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(9);
});
var AdvantageTitle = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, (0,_object_spread/* default */.Z)({
        component: "h3",
        fontSize: {
            xs: 18,
            sm: 20,
            md: 36
        },
        mb: 1,
        fontWeight: 600
    }, props));
};
var AdvantageDescription = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, (0,_object_spread/* default */.Z)({
        fontSize: {
            xs: 14,
            sm: 16
        }
    }, props));
};
/* harmony default export */ var foodProgram_Advantages = (Advantages);


/***/ })

}]);